export default "__VITE_ASSET__CF132eQL__ 720w";